var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file form的插槽组件
 * @author (zhaojun10)
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * 参数说明
 * type         必需，表单元素类型[input,checkbox,radio,textarea,button,select]
 * submit       可选，提交动作触发回调结果，如果form有submit，那form的submit会替代次submit,参数说明见form
 * rules        可选，验证数组，每个元素一条验证规则，带message和validate函数
 * submitFlag   可选，专用于button，当为true时会触发提交
 * 其他属性      参照对应type类型表单元素，此组件只做透传
 */

var FormItem = function (_PureComponent) {
    _inherits(FormItem, _PureComponent);

    function FormItem(props) {
        _classCallCheck(this, FormItem);

        var _this = _possibleConstructorReturn(this, (FormItem.__proto__ || Object.getPrototypeOf(FormItem)).call(this, props));

        _this.state = {};
        _this.timer = null;
        return _this;
    }

    _createClass(FormItem, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children;


            var classes = classnames(_defineProperty({}, className, className));

            return React.createElement(
                'div',
                { className: classes },
                children
            );
        }
    }]);

    return FormItem;
}(PureComponent);

FormItem.propTypes = {
    type: PropTypes.string.isRequired,
    order: PropTypes.number,
    submit: PropTypes.func,
    disable: PropTypes.bool,
    hidden: PropTypes.bool,
    styleType: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    name: PropTypes.string.isRequired,
    rules: PropTypes.array,
    classPrefix: PropTypes.string,
    label: PropTypes.node,
    placeHolder: PropTypes.string,
    optionData: PropTypes.array,
    children: PropTypes.node,
    className: PropTypes.string,
    height: PropTypes.string,
    max: PropTypes.number,
    increment: PropTypes.number,
    onHandleChange: PropTypes.func,
    submitFlag: PropTypes.bool,
    readOnly: PropTypes.bool,
    getValue: PropTypes.func,
    validate: PropTypes.any,
    countFlag: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    noWaining: PropTypes.bool,
    star: PropTypes.bool,
    tips: PropTypes.node,
    defaultValue: PropTypes.string,
    onClick: PropTypes.func,
    horizontal: PropTypes.bool,
    vertical: PropTypes.bool,
    noDistance: PropTypes.bool,
    disabled: PropTypes.bool,
    value: PropTypes.any
};
export default FormItem;